import { render, staticRenderFns } from "./ModalShowReel.vue?vue&type=template&id=64002f23&scoped=true&"
import script from "./ModalShowReel.vue?vue&type=script&lang=js&"
export * from "./ModalShowReel.vue?vue&type=script&lang=js&"
import style0 from "./ModalShowReel.vue?vue&type=style&index=0&id=64002f23&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64002f23",
  null
  
)

export default component.exports